var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.867C2 7.241 6.627 3.51 12 3.51c1.602 0 3.251.229 4.573 1.187l-1.218 1.57c-.792-.575-1.9-.796-3.355-.796-4.552 0-7.97 3.122-7.97 6.396 0 1.59.916 3.114 2.496 4.277 1.577 1.16 3.738 1.894 6.002 1.894.492 0 .605-.113.625-.133.057-.056.136-.189.224-.58.019-.086.04-.197.064-.324.061-.319.14-.735.25-1.088.174-.558.469-1.173 1.054-1.7.534-.48 1.254-.736 1.863-.91.32-.09.65-.17.962-.242l.106-.025c.279-.065.54-.126.793-.193.59-.157.991-.311 1.24-.49.189-.137.261-.26.261-.486 0-1.215-.224-2.144-1.074-3.093l1.535-1.284C21.696 8.903 22 10.344 22 11.867c0 .924-.445 1.601-1.077 2.057-.573.414-1.295.646-1.918.81-.284.076-.577.144-.851.209l-.106.024c-.312.073-.6.142-.866.218-.562.16-.888.315-1.056.466-.238.214-.383.479-.49.826-.08.255-.12.471-.168.727-.03.156-.062.328-.107.533-.099.444-.27 1.056-.753 1.536-.522.518-1.239.727-2.08.727-2.697 0-5.293-.868-7.232-2.295C3.359 16.279 2 14.228 2 11.867Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21.967 4.387-8.72 8.43-1.436-1.388L20.531 3l1.436 1.387ZM11.239 9.395c.7 0 1.268-.55 1.268-1.226 0-.677-.568-1.226-1.268-1.226-.7 0-1.269.549-1.269 1.226 0 .677.568 1.226 1.269 1.226Zm-2.283.245c0 .677-.568 1.226-1.269 1.226-.7 0-1.268-.549-1.268-1.226 0-.677.567-1.226 1.268-1.226.7 0 1.269.549 1.269 1.226ZM7.18 14.79c.7 0 1.268-.55 1.268-1.227s-.568-1.226-1.268-1.226c-.701 0-1.269.55-1.269 1.226 0 .677.568 1.226 1.269 1.226v.001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/palette.d733810a.svg";
export { ForwardRef as ReactComponent };